import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readIvaByEmisor: (_idEmisor, start, end) =>
    api
      .send({
        query: gql`
          query readByEmisor($_idEmisor: ID!, $start: Date!, $end: Date!) {
            Iva {
              readByEmisor(_idEmisor: $_idEmisor, start: $start, end: $end) {
                ventas {
                  _id {
                    tarifa
                    clasificacion
                  }
                  subtotal
                  totalImpuesto
                }
                compras {
                  _id {
                    tarifa
                    clasificacion
                  }
                  subtotal
                  totalImpuesto
                }
              }
            }
          }
        `,
        variables: {
          _idEmisor,
          start,
          end
        }
      })
      .then(result => result.data.data.Iva.readByEmisor)
}
